var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotifTrusted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 296,
    viewBox: "0 0 220 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L220 84.7138V296L0 211.286V0Z",
    fill: "#BBFF73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifTrusted);
export default __webpack_public_path__ + "static/media/motif-trusted.4ddf1c372f72061f577074484066eb84.svg";
export { ForwardRef as ReactComponent };